import {mapActions, mapGetters, mapMutations} from "vuex";
import Utils from "../components.utils.js"
import Constants from "../components.constants.js";
import {NotifierConstants} from "../components.constants.js";

const highlightMixin = {
    data(){
        return{
            viewProfileSelection:false,
            isCatalogBrowse:false,
            selectedTagIds:[],
            picklistName:"",
            categoryIdNameMap:{
                _id:"",
                name:""
            },
            viewfieldInfoIds:[],
            selectedCatParentIdPathList:[],
            selectedCatParentIdList:[],
            postcatalogKey:[],
            categoryListFromAutocomplete:[],
            picklistFromAutocomplete:[],
            mediaSlug:"",
            description:"",
            assetCustomMetadata :[],
            customMetadataList: [],
            metadataProfileList:[],
            displayUserMetadataIdOrder:[],
            singlePicklistData:{},
            picklistData:{},
            tagsMapper:[],
            tagNamesList:[],
            tagNamesData: "",
            tagsListFromAutocomplete:[],
            tagsList:[],
            route:"",
            activeField:"",
            nonEditableFields: false,
            selectedRelaventProfileIdList:["All"],
            profileDetails:{
              "display_description":0,
              "custom_metadata_display_config":0,
              "tag_display_config":0,
              "tag_displayall_config":0,
              "custom_metadata_id_list":[],
              "custom_metadata_allId_list":0,
              "tag_id_list":[]
            },
            relevantProfilesList:[],
            displayAlwaysFieldsIdList:[],
            fetchedFieldIdList:[],
            fetchedTagIdList:[],
            uploadScreenInfo:{
              "field_id_list":[],
              "read_only_field_id_list":[],
              "mandatory_field_id_list":[],
              "display_always_field_id_list":[]
            },
            checkedProfiles:[],
            hiddenFieldIdList:[],
            assetDetailsFromParent:{},
            enableCatalog:false,
            enableFieldsWithMetadataPriv:true,
            showSystemDefinedMetadata:true,
            picklistValDummy:[],
            tempDefaultCatalogFromParent : [],
            parentAssetDetails:{},
            defaultAssetsBrowseAccess:['full-control','read-modify','read-write','read']
        };
    },

    computed:{
        ...mapGetters("users",["getLoggedInUserId"]),
        ...mapGetters("categories", ["getSelectedCategoryInCategoryBrowse","getRootCategoryDetails"]),
        globalSettingsFromStartup:{
            get(){
                return this.$store.state.startUpData.startUpDataDetails;
            }
        },
        isTypeCatalog(){
            try {
                if('asset_type' in this.parentData){
                    return ["catalog"].includes(this.parentData.asset_type)
                }
            } catch (err) {
                console.error(`[isTypeCatalog][folder][Error while checking folderType-${err}]`)
            }
            return false
        },
        tagIdNameMapper(){
            return this.tagsMapper
        },
        getTagIds(){
            if(this.jobInfoFromUploadPanel != undefined){
                if ("metadata" in this.jobInfoFromUploadPanel){
                    if ("tag_ids" in this.jobInfoFromUploadPanel.metadata){
                        return this.jobInfoFromUploadPanel.metadata.tag_ids
                    }
                }
                return []  
            }
            return []  
        },
    },
    methods:{
        isChildExists(parentInfo){
            let childPresent = false
            this.customMetadataList.filter(obj=>{
                if('load_when' in obj && obj.load_when.find(op=>op.id == parentInfo._id)){
                    childPresent =  true;
                    return childPresent
                }
            })
            return childPresent
        },
        getHierarchyMetadata(parentInfo){
            let items = this.customMetadataList.filter(obj => obj.load_when)
            items.push(parentInfo)
            let map = {};
            let roots = [];
      
            // Create a map of items with their IDs
            items.forEach(item => {
                map[item._id] = { ...item, children: [] };
            });
            // Build the hierarchy
            items.forEach(item => {
                if (item.load_when && item.load_when.length) {
                    item.load_when.forEach(condition => {
                        let parent = map[condition.id];
                        if (parent) {
                            let isFieldValueMatched = false;
                            let exp = item.load_when.find(op=>op.id == condition.id);
                            if(exp){
                              
                              if(Array.isArray(exp.value) && exp.value.length == 0){
                                  isFieldValueMatched = true
                              }else if(Object.keys(exp.value).length == 0){
                                  isFieldValueMatched = true
                              }else{
                                  // If parent expression is added,  then validate
                                  let metadata = this.assetCustomMetadata;
                                  if(this.onGoingChanges){
                                    metadata = this.onGoingChanges;
                                  }
                                  let fieldEntryDetails = metadata.find(item=>item.key_id == condition.id);
                                  if(fieldEntryDetails){
                                      if(["FREETEXT","FREETEXT_MULTILINE"].includes(exp.type)){
                                          if(exp.value == fieldEntryDetails.value[0]){
                                              isFieldValueMatched = true;
                                          }
                                      }else if(["DATE"].includes(exp.type)){
                                          let fieldDate = fieldEntryDetails.value[0];
                                          let fromDate = exp.value[0];
                                          let toDate = exp.value[1];
                                          if(fromDate <= fieldDate && fieldDate <= toDate){
                                              isFieldValueMatched = true;
                                          }
                                      }else if(["DATE_TIME"].includes(exp.type)){
                                          let fieldDate = fieldEntryDetails.value[0];
                                          fieldDate = fieldDate.replace("T"," ");
                                          let fromDate = exp.value[0];
                                          fromDate = fromDate.replace("T", " ")
                                          let toDate = exp.value[1];
                                          toDate = toDate.replace("T"," ");
                                          if(fromDate <= fieldDate && fieldDate <= toDate){
                                              isFieldValueMatched = true;
                                          }
                                      }else if(["INTEGER"].includes(exp.type)){
                                          if(fieldEntryDetails.value[0] >= exp.value["from"] && fieldEntryDetails.value[0] <= exp.value["to"]){
                                              isFieldValueMatched = true;
                                          }
                                      }else if(["PICKLIST","PICKLIST_MULTIVALUE"].includes(exp.type)){
                                          for(let val of exp.value){
                                              if(!fieldEntryDetails.value.includes(val)){
                                                  isFieldValueMatched = false;
                                                  break;
                                              }
                                              isFieldValueMatched = true;
                                          }
                                      }
                                  }
                              }
                              if(isFieldValueMatched){
                                  parent.children.push(map[item._id]);
                              }
                            }
                        }
                    });
                } else {
                    roots.push(map[item._id]);
                }
            });
            let matchedHM =  roots.filter(op=>op._id == parentInfo._id);
            if(matchedHM.length > 0){
              return [matchedHM[0]]
            }
            console.log("****************************** ", parentInfo.name , matchedHM)
            return matchedHM;
        },
        getCustomMetadataName(fieldInfo){
            if('language_alias_mapper' in fieldInfo && fieldInfo.language_alias_mapper && fieldInfo.language_alias_mapper.length > 0 && this.$i18n && this.$i18n.locale){
              let mapperExists = fieldInfo.language_alias_mapper.find(op=>op.code == this.$i18n.locale)
              if(mapperExists && Object.keys(mapperExists).length > 0 && mapperExists.field_alias && mapperExists.field_alias.length > 0){
                return mapperExists.field_alias;
              }
            }
            return fieldInfo.name;
          },
          openParentAssetDescriptionDialog(){
            this.$emit("openParentAssetDescriptionDialog")
          },
          //catalogs.......................
          getCatParentName(catalogInfo){
            if('parent_path' in catalogInfo){
              return catalogInfo.parent_path["value"]
            }
            return ""
          },
          getSelectedCatalogsArr(){
            return this.selectedCatParentIdPathList;
          },
          updatedCatalogsListComp(option){
            let newVal = option.parent_id_path + "/" + option._id
            if(!this.selectedCatParentIdList.includes(newVal)){
              let enabledMultiSelect = this.globalSettingsFromStartup && this.globalSettingsFromStartup.enable_multi_catalog_browse
              if(enabledMultiSelect){
                this.selectedCatParentIdList.push(newVal);
              }else{
                this.selectedCatParentIdList = [newVal];
              }
              if(this.ismediaEdit){
                if(enabledMultiSelect){
                  let index = this.selectedCatParentIdPathList.findIndex(e => e._id == option._id);
                  if(index <= -1){
                    this.selectedCatParentIdPathList.push(option)
                    this.$emit("selectedCatalogFromChild",this.selectedCatParentIdPathList);
                  }
                }else{
                  this.selectedCatParentIdPathList = [option]
                  this.$emit("selectedCatalogFromChild",this.selectedCatParentIdPathList);
                }
              }
            }
            if(this.enableOnlyFields != true ){
              this.fetchAndLoadRelaventMetadataProfiles(this.assetCustomMetadata)
            }
          },
          removedCatalogFromList(option){
            if(this.selectedCatParentIdList.includes(option.parent_id_path + "/" + option._id) || this.selectedCatParentIdPathList.findIndex(e => e._id == option._id) > -1){
              this.selectedCatParentIdList = this.selectedCatParentIdList.filter(op=>op != (option.parent_id_path + "/" + option._id));
              if(this.ismediaEdit){
                this.selectedCatParentIdPathList = this.selectedCatParentIdPathList.filter(op=>op._id != option._id );
                this.$emit("selectedCatalogFromChild",this.selectedCatParentIdPathList);
              }
            }   
          },
          //...............
          //profiles
          screenProfileLabelCallback(option){
            return this.getSelectedProfileName(option.metadata_profile_id)
          },
          getSelectedProfileName(rpId){
            let profileInfo = this.relevantProfilesList.filter((STemplate)=>STemplate.metadata_profile_id == rpId);
            if(profileInfo.length > 0){
              return profileInfo[0].name;
            }
            return "";
          },
          removeSelectedOption(option){
            this.checkedProfiles = this.checkedProfiles.filter(e => e.metadata_profile_id != option.metadata_profile_id)
            this.removeProfile(option);
          },
          removeProfile(option){
            let index = this.checkedProfiles.findIndex(item => item.metadata_profile_id == option.metadata_profile_id);
            if(index > -1){
                this.checkedProfiles[index].checked = false;
            }
            this.selectedRelaventProfileIdList.splice(this.selectedRelaventProfileIdList.indexOf(option.metadata_profile_id),1);
            let STemplateDetails = this.metadataProfileList.filter((STemplate)=>STemplate._id == option.metadata_profile_id);
            if(typeof STemplateDetails != "undefined" && STemplateDetails.length > 0){
              for(let pFKey of STemplateDetails[0].custom_metadata_id_list){
                // if(this.uploadScreenInfo["field_id_list"].includes(pFKey)){
                //   this.uploadScreenInfo["field_id_list"].splice(this.uploadScreenInfo["field_id_list"].indexOf(pFKey),1);
                // }
                if(this.hiddenFieldIdList.includes(pFKey)){
                  this.hiddenFieldIdList.splice(this.hiddenFieldIdList.indexOf(pFKey),1);
                }
              }
            }
            if(this.selectedRelaventProfileIdList.length <= 0){
              this.selectedRelaventProfileIdList.push('All');
            }
            this.updateFieldsView();
          },
          makeProfileCheckBoxSelection(option){
              return this.checkedProfiles.some((op) => op.metadata_profile_id === option.metadata_profile_id);
          },
          selectProfile(option){
            if(this.selectedRelaventProfileIdList.length ==1 &&
              this.selectedRelaventProfileIdList.includes('All')){
              this.selectedRelaventProfileIdList.splice(this.selectedRelaventProfileIdList.indexOf('All'),1);
            }
            if(!this.selectedRelaventProfileIdList.includes(option.metadata_profile_id)){
              this.selectedRelaventProfileIdList.push(option.metadata_profile_id);
              let index = this.relevantProfilesList.findIndex(item => item.metadata_profile_id == option.metadata_profile_id);
              if(index > -1){
                  this.relevantProfilesList[index].checked = true;
              }
              let STemplateDetails = this.metadataProfileList.filter((STemplate)=>STemplate._id == option.metadata_profile_id);
              if(typeof STemplateDetails != "undefined" && STemplateDetails.length > 0){
                for(let pFKey of STemplateDetails[0].custom_metadata_id_list){
                  if(!this.uploadScreenInfo["field_id_list"].includes(pFKey) && !this.hiddenFieldIdList.includes(pFKey)){
                    this.hiddenFieldIdList.push(pFKey);
                  }
                }
              }
            }
            if(this.selectedRelaventProfileIdList.length <= 0){
              this.selectedRelaventProfileIdList.push('All');
            }
            this.updateFieldsView();
          }, 
          //......................................................
    
          //Tags....................................................
          isFieldDescriptionEnabled(fieldId){
            if(this.viewfieldInfoIds.indexOf(fieldId) == -1){
              return false;
            }else{
              return true;
            }
          },
          enableOrDisableFieldInfo(fieldId){
            if(this.viewfieldInfoIds.indexOf(fieldId) == -1){
              this.viewfieldInfoIds.push(fieldId);
            }
            else{
              this.viewfieldInfoIds.splice(this.viewfieldInfoIds.indexOf(fieldId),1);
            }
          },
          inactivateField(){
            this.activeField = "";
          },
          getTagsOnKeyup(){
              let payload = {};
              // if(query.length > 0 && query != undefined){
                payload.params = {name:this.tagNamesData};
                this.getTagsOnAutocomplete(payload).then((data)=>{
                  this.tagsListFromAutocomplete = data.tags;
                });
                this.tagsListFromAutocomplete = []
              // }
              
            },
          picklistTypeCheck(custommetadata){
            let res =  custommetadata.type == 'PICKLIST_MULTIVALUE';
            if(res){
              if(!(custommetadata._id in this.picklistData) ||
                  (custommetadata._id in this.picklistData && this.picklistData[custommetadata._id].length <= 0)){
                this.picklistData[custommetadata._id] = this.getCustomMetadataById(custommetadata._id, true, custommetadata)
              }
            }
            return res
          },
        singlePicklistTypeCheck(custommetadata){
          let res =  custommetadata.type == 'PICKLIST';
          if(res){
            if(!(custommetadata._id in this.picklistData)){
              this.singlePicklistData[custommetadata._id] = this.getCustomMetadataById(custommetadata._id, true, custommetadata)
            }
          }
          return res
        },
          deleteTagsFromList(value,arr){
              let itemToBeRemoved = value
              let findIndex = arr.findIndex(a => a._id === itemToBeRemoved._id)
              findIndex !== -1 && arr.splice(findIndex , 1)
            },
          getUnique(array){
            var uniqueArray = [];
            
            // Loop through array values
            for(let i=0; i < array.length; i++){
                if(uniqueArray.indexOf(array[i]) === -1) {
                    uniqueArray.push(array[i]);
                }
            }
            return uniqueArray;
            },
            customLabelPicklistSingleVal(option){
              return `${option.value}`
            },
            getSinglePicklistVal(id){
              if(this.singlePicklistData != undefined && this.singlePicklistData[id] != undefined){
                return this.singlePicklistData[id];
              }
              return "";
            },
            getCustomMetadataById(id, multiValues=false, fieldEntry={}){
              if(this.assetCustomMetadata.length != 0){
                let cmdata = this.assetCustomMetadata.filter((cdata)=>cdata.key_id == id)[0];
                if(cmdata != undefined){
                  if(["PICKLIST_MULTIVALUE", "PICKLIST"].includes(cmdata.type)){
                    let u = [];
                    for(let v of cmdata.value){
                      let vF = fieldEntry.values.filter(op=>op.value_id == v)
                      if(vF.length){
                        u.push(vF[0])
                      }
                    }
                    return u;
                  }
                  if(cmdata.value.length > 1){
                    return cmdata.value;
                  }else if(multiValues){
                    return cmdata.value;
                  }else if(["DATE_TIME"].includes(cmdata.type)){
                    let cVal = cmdata.value[0];
                    cVal = cVal.replace("T", " ");
                    return cVal;
                  }else{
                    return cmdata.value[0];
                  }
                }
              }
              return ""
            },
            updateMediaValue(value = null){
              this.mediaSlug = value;
            },
            updateCustomMetadataById(editingCustomMetadata, value=null){
                if (value == null ||
                    [undefined,null].includes(editingCustomMetadata) ||
                      Object.keys(editingCustomMetadata).length <= 0){
                    return
                }
                let updatedVal = null
                this.assetCustomMetadata = this.assetCustomMetadata.filter((cmdata)=>cmdata.key_id != editingCustomMetadata._id)
                if(editingCustomMetadata.type == "PICKLIST_MULTIVALUE"){
                  updatedVal = []
                  for(let op of this.picklistData[editingCustomMetadata._id]){
                    updatedVal.push(op.value_id);
                  }
                }else if(editingCustomMetadata.type == "PICKLIST"){
                  this.singlePicklistData[editingCustomMetadata._id] = value
                  updatedVal = [value.value_id];
                }else if(editingCustomMetadata.type == "DATE_TIME"){
                  updatedVal = value
                  updatedVal= [updatedVal.replace(" ","T")];
                }else{
                  updatedVal = [value]
                }
                let customKeyValue = {
                    key_id : editingCustomMetadata._id,
                    type : editingCustomMetadata.type,
                    value: updatedVal,
                }
               this.assetCustomMetadata.push(customKeyValue)
               this.$emit("updatedCM", this.assetCustomMetadata)
               if(this.enableOnlyFields != true){
                this.fetchAndLoadRelaventMetadataProfiles(this.assetCustomMetadata)
               }
            },
            handleCMUpdate(metadata){
                this.assetCustomMetadata = metadata;
                this.$emit("updatedCM", this.assetCustomMetadata)
            },
            getCategoryRoutefromId(catId){
              let temp = {};
                  if(Object.prototype.toString.call(catId) === '[object Object]'){
                    catId = [catId]
                  }
                  if (catId){
                    for(let c =0; c < catId.length; c++){
                      if("parent_id_path" in catId[c]){
                          temp = catId[c];
                      }else{
                        let payload = {};
                        payload.params = {_id:catId[c]._id}
                        this.getAllAssetsFromServer(payload).then((data) => {
                          temp = data.assets[0]
                        });
                      }
                      if(!this.selectedCatParentIdList.includes(temp.parent_id_path + "/"+temp._id)){
                        this.selectedCatParentIdList.push(temp.parent_id_path + "/" + temp._id);
                        this.selectedCatParentIdPathList.unshift(temp);
                      }
                      this.$emit("selectedCatalogFromChild",this.selectedCatParentIdPathList)
    
                      if(this.enableOnlyFields!= true){
                        this.fetchAndLoadRelaventMetadataProfiles()
                      }
                      this.route = catId[c]
                    }
                } 
             
              return this.route
            },
            handleCatalogSelection(categoryId){
                this.getCategoryRoutefromId(categoryId)
            },
            isMandatoryKeysSkipped(allowEmptyMandVal=true){
              let isMandatoryFieldExists = false;
              for(let i=0; i<this.uploadScreenInfo.mandatory_field_id_list.length; i++){
                let defaultFields = this.uploadScreenInfo.mandatory_field_id_list[i];

                //This check is added to avoid if any madatory field is deleted but still present in screen level mandatory fields
                let startupFieldIndex = this.getStartUpDataFromInCache()["custom_metadatas"].findIndex(op=>op._id == defaultFields)
                if(startupFieldIndex < 0){
                  console.log("Mandatory field is not avialable in startup data. Hence skipped.")
                  continue;
                }

                if(!this.uploadScreenInfo.field_id_list.includes(defaultFields)){
                    continue;
                }
                if(((typeof this.profileDetails != "undefined" && "custom_metadata_id_list" in this.profileDetails 
                    && this.profileDetails.custom_metadata_id_list.includes(defaultFields)) || this.selectedRelaventProfileIdList.includes("All"))){
                  let metadataEntry = this.assetCustomMetadata.filter((cmdata)=>cmdata.key_id == defaultFields)
                  if(typeof metadataEntry != "undefined" && metadataEntry.length > 0){
                    let eachMetadata = metadataEntry[0];
                    let valuesList = []
                    Object.assign(valuesList, eachMetadata.value);
                    if(valuesList.length <= 0){
                      isMandatoryFieldExists = true;
                      break;
                    }else{
                      for (let i = 0; i<valuesList.length; i++){
                        if(valuesList[i] == null || typeof valuesList[i] == "undefined" || valuesList[i].trim().length <= 0){
                          isMandatoryFieldExists = true;
                          break;
                        }
                      }
                    }
                  }else{
                    isMandatoryFieldExists = true;
                    break;
                  }
                }
              }
              if(isMandatoryFieldExists){
                if(allowEmptyMandVal){
                  if (confirm("Few Mandatory field(s) value(s) is empty. Do you want to update with empty value?. ")){
                    return false;
                  }else{
                    return true;
                  }
                }else{
                  alert("Few Mandatory field(s) value(s) is empty. Please add valid value(s).")
                  return true;
                }
              }
              return false;
            },
            getAssetMTagIds(){
              let idList = [];
              if('metadata' in this.assetDetailsFromParent && ![undefined, null].includes(this.assetDetailsFromParent.metadata) &&
                'tag_ids' in this.assetDetailsFromParent.metadata && ![undefined, null].includes(this.assetDetailsFromParent.metadata['tag_ids'])){
                idList = this.assetDetailsFromParent.metadata['tag_ids']
              }
              return idList
            },
            getCatalogDetails(){
              if(this.selectedCatParentIdList && this.selectedCatParentIdList.length > 0){
                return this.selectedCatParentIdList.filter(e => e != "catalog_id://0")
              }
              return []
            },
            getSequenceMetadataMap(allowEmptyMandVal=true){
              if(this.isMandatoryKeysSkipped(allowEmptyMandVal)){
                return null;
              }
              if(this.enableOnlyFields){
                return this.assetCustomMetadata;
              }
              let tagIds = [];
              if(this.$refs.tagsComponent && typeof this.$refs.tagsComponent.getSelectedTagIdList === 'function' && this.$refs.tagsComponent.getSelectedTagIdList()){
                tagIds = this.$refs.tagsComponent.getSelectedTagIdList();
              }else if(this.$refs.tagsComponent && typeof this.$refs.tagsComponent[0].getSelectedTagIdList === 'function' && this.$refs.tagsComponent[0].getSelectedTagIdList()){
                tagIds = this.$refs.tagsComponent[0].getSelectedTagIdList();
              }
    
              if(this.selectedCatParentIdList && this.selectedCatParentIdList.length > 0){
                this.selectedCatParentIdList = this.selectedCatParentIdList.filter(e => e != "catalog_id://0")
              }

              let postMetadatamap ={
                    metadata: {
                        description : this.description,
                        tag_ids : tagIds,
                    },
                    parent_id_path:this.selectedCatParentIdList,
                    custom_metadata: this.assetCustomMetadata
                }
                if(this.enableMediaSlug){
                  postMetadatamap["slug_name"] = this.mediaSlug;
                }
                return postMetadatamap
            },
            updateFieldsView(){
              this.profileDetails = {
                "display_description":0,
                "custom_metadata_display_config":0,
                "tag_display_config":0,
                "tag_displayall_config":0,
                "custom_metadata_id_list":[],
                "custom_metadata_allId_list":0,
                "tag_id_list":[]
              },
              this.fetchedFieldIdList = [];
              this.fetchedTagIdList = [];
              if(this.selectedRelaventProfileIdList != undefined && this.selectedRelaventProfileIdList.length > 0){
                for(let i= 0; i<this.selectedRelaventProfileIdList.length;i++){
                  if(this.selectedRelaventProfileIdList[i] == 'All'){
                    this.fetchedFieldIdList.concat(this.uploadScreenInfo.field_id_list)
                  }
                  let STemplateDetails = this.metadataProfileList.filter((STemplate)=>STemplate._id == this.selectedRelaventProfileIdList[i]);
                  if(typeof STemplateDetails != "undefined" && STemplateDetails.length > 0){
                    let profileDetail = {};
                    Object.assign(profileDetail,STemplateDetails[0]);
    
                    //profile fields count
                    if(profileDetail.custom_metadata_id_list != undefined && profileDetail.custom_metadata_id_list.length > 0){
                      this.profileDetails.custom_metadata_display_config = this.profileDetails.custom_metadata_display_config + 1;
                    }
                    //profile tags
                    if(profileDetail.tag_display_all == true){
                      this.profileDetails.tag_displayall_config = this.profileDetails.tag_displayall_config + 1;
                    }else if(profileDetail.tag_id_list != undefined && profileDetail.tag_id_list.length > 0){
                      this.profileDetails.tag_display_config = this.profileDetails.tag_display_config + 1;
                    }
                    if(typeof profileDetail.tag_id_list != "undefined" && profileDetail.tag_id_list.length > 0){
                      let tagList = [];
                      Object.assign(tagList, profileDetail.tag_id_list);
                      for(let tag of profileDetail.tag_id_list){
                        if(!this.fetchedTagIdList.includes(tag)){
                          this.fetchedTagIdList.push(tag);
                        }
                      }
                    }
                    this.fetchedTagIdList.concat(profileDetail.tag_id_list);
    
                    //profile fields
                    let idList = profileDetail.custom_metadata_id_list;
                    for(let fId of idList){
                      if(this.fetchedFieldIdList.indexOf(fId) == -1 &&
                        this.displayAlwaysFieldsIdList.indexOf(fId) == -1){
                          this.fetchedFieldIdList.push(fId);
                      }else if(!this.hiddenFieldIdList.includes(fId)){
                        this.hiddenFieldIdList.push(fId);
                      }
                      if(!this.uploadScreenInfo.field_id_list.includes(fId) && !this.hiddenFieldIdList.includes(fId)){
                        this.hiddenFieldIdList.push(fId);
                      }
                    }
                  }
                }
                for(let sId of this.uploadScreenInfo.field_id_list){
                  if(![undefined, null].includes(this.checkedProfiles) && this.checkedProfiles.length > 0 &&
                     !this.fetchedFieldIdList.includes(sId) && !this.hiddenFieldIdList.includes(sId) &&
                     !this.displayAlwaysFieldsIdList.includes(sId)){
                    this.hiddenFieldIdList.push(sId);
                  }
                }
              }else{
                this.hiddenFieldIdList = this.uploadScreenInfo.field_id_list;
              }
          },
            handleHiddenFieldsView(){
              this.showHiddenFields = true;
              // if(this.hiddenFieldIdList != undefined && this.hiddenFieldIdList.length > 0){
              //   for(let eId of this.hiddenFieldIdList){
              //     if(!this.uploadScreenInfo["field_id_list"].includes(eId)){
              //       this.uploadScreenInfo["field_id_list"].push(eId);
              //     }
              //   }
              // }
              this.hiddenFieldIdList = [];
              this.selectedRelaventProfileIdList.push('All');
          },
    
            //PICKLIST MULTIVALUE.............................
            removeSelectedPicklistOption(option,fieldInfo){
              this.picklistData[fieldInfo._id] = this.picklistData[fieldInfo._id].filter(e => e.value_id != option.value_id);
              let editInfo = Object.assign({},option);
              editInfo.type = fieldInfo.type;
              editInfo._id = fieldInfo._id;
              editInfo.type = fieldInfo.type;
              this.updateCustomMetadataById(editInfo,fieldInfo._id);
              this.makePicklistCheckBoxSelection(option,fieldInfo._id);
            },
            makePicklistCheckBoxSelection(option,id){
              if(this.picklistData[id] != undefined && typeof(this.picklistData[id]) != 'string'){
                return this.picklistData[id].some((op) => op.value_id === option.value_id);
              }
            },
            getPicklistSingleSelectOptions(option,id){
              console.log("options",option,id,this.$refs[id][0].search);
              // let keyword  = this.$refs[id][0].search;
              
              return option;
            },
            //....................................
            isFieldType(fieldType){
              return ["FREETEXT","FREETEXT_MULTILINE","DATE","DATE_TIME","INTEGER","PICKLIST","PICKLIST_MULTIVALUE"].includes(fieldType);
            },
            fetchAndLoadRelaventMetadataProfiles(assetFieldEntries){
              // this.showHiddenFields = false;
              this.hiddenFieldIdList = [];
              let profileList = [];
              if(this.metadataProfileList != undefined && this.metadataProfileList.length > 0){
                this.selectedRelaventProfileIdList = [];
                this.checkedProfiles = [];
                this.relevantProfilesList = [];
                for(let ItemS of this.metadataProfileList){
                  let isProfileMatched = [];
                  if(ItemS.load_when != undefined && ItemS.load_when.length > 0){
                    for(let loadT of ItemS.load_when){
                      if(loadT.type == Constants.loadWhenCatalog){
                        let catIdList = [];
                        if(this.selectedCatParentIdList != undefined && this.selectedCatParentIdList.length > 0){
                          catIdList = this.selectedCatParentIdList;
                        }
                        let iscatIncludes = false;
                        for(let eachCatId of loadT.id_list){
                          if(catIdList.includes(eachCatId)){
                            iscatIncludes = true;
                          }
                        }
                        if(iscatIncludes){
                          isProfileMatched.push(true);
                        }else{
                          isProfileMatched.push(false);
                          break;
                        }
                      }else if(loadT.type == Constants.loadWhenMimeTypes){
                        if(loadT.value == this.isAudioFile){
                          isProfileMatched.push(true);
                        }else{
                          isProfileMatched.push(false);
                          break;
                        }
                      }else if(loadT.type == Constants.loadWhenScreenName){
                        if(loadT.id_list.includes(this.tagMetadataScreenId)){
                          isProfileMatched.push(true);
                        }else{
                          isProfileMatched.push(false);
                          break;
                        }
                      }else if(loadT.type == Constants.loadWhenUserName){
                        if(loadT.id_list.includes(this.getLoggedInUserId)){
                          isProfileMatched.push(true);
                        }else{
                          isProfileMatched.push(false);
                          break;
                        }
                      }else if(loadT.type == Constants.loadWhenGroupName){
                        if(Utils.isUserExistsInOneSpecificGroupList(this.getLoggedInUserId, loadT.id_list, this.startupUserGroupList)){
                          isProfileMatched.push(true);
                        }else{
                          isProfileMatched.push(false);
                          break;
                        }
                      }else if(loadT.type == Constants.loadWhenAdvancedExp){
                        //loadWhen Advance exp. matches
                      }else if(this.isFieldType(loadT.type)){
                        for(let fId of loadT.id_list){
                          if(assetFieldEntries == undefined || assetFieldEntries.length <= 0){
                            continue;
                          }
                          let fieldEntryDetails = assetFieldEntries.filter(item=>item.key_id == fId);
                          if(fieldEntryDetails == undefined || fieldEntryDetails.length <= 0){
                            isProfileMatched.push(false);
                            break;
                          }
                          let isFieldValueMatched = false;
                          if(["FREETEXT","FREETEXT_MULTILINE"].includes(loadT.type)){
                            if(loadT.value == fieldEntryDetails[0].value[0]){
                              isFieldValueMatched = true;
                            }
                          }else if(["DATE"].includes(loadT.type)){
                            let fieldDate = fieldEntryDetails[0].value[0];
                            let fromDate = loadT.value[0];
                            let toDate = loadT.value[1];
                            if(fromDate <= fieldDate && fieldDate <= toDate){
                              isFieldValueMatched = true;
                            }
                          }else if(["DATE_TIME"].includes(loadT.type)){
                            let fieldDate = fieldEntryDetails[0].value[0];
                            fieldDate = fieldDate.replace("T"," ");
                            let fromDate = loadT.value[0];
                            fromDate = fromDate.replace("T", " ")
                            let toDate = loadT.value[1];
                            toDate = toDate.replace("T"," ");
                            if(fromDate <= fieldDate && fieldDate <= toDate){
                              isFieldValueMatched = true;
                            }
                          }else if(["INTEGER"].includes(loadT.type)){
                            if(fieldEntryDetails[0].value[0] >= loadT.value["from"] && fieldEntryDetails[0].value[0] <= loadT.value["to"]){
                              isFieldValueMatched = true;
                            }
                          }else if(["PICKLIST","PICKLIST_MULTIVALUE"].includes(loadT.type)){
                            for(let val of loadT.value){
                              if(!fieldEntryDetails[0].value.includes(val)){
                                isFieldValueMatched = false;
                                break;
                              }
                              isFieldValueMatched = true;
                            }
                          }
                          if(isFieldValueMatched){
                            isProfileMatched.push(true);
                          }else{
                            isProfileMatched.push(false);
                            break;
                          }
                        }
                      }
                    }
                    if(isProfileMatched.includes(false)){
                      if(this.selectedRelaventProfileIdList != undefined &&
                        this.selectedRelaventProfileIdList.includes(ItemS._id)){
                        this.selectedRelaventProfileIdList.splice(this.selectedRelaventProfileIdList.indexOf(ItemS._id), 1)
                        this.checkedProfiles = this.checkedProfiles.filter(item => item.metadata_profile_id != ItemS._id)
                      }
                    }else if(isProfileMatched.length > 0){
                      profileList.push({
                        "metadata_profile_id":ItemS._id,
                        "name":ItemS.name
                      })
                      this.selectedRelaventProfileIdList.push(ItemS._id);
                    }
                  }else if(!this.selectedRelaventProfileIdList.includes(ItemS._id)){
                    profileList.push({
                      "metadata_profile_id":ItemS._id,
                      "name":ItemS.name
                    })
                    this.selectedRelaventProfileIdList.push(ItemS._id);
                  }
                }
                if(this.selectedRelaventProfileIdList == undefined ||
                this.selectedRelaventProfileIdList.length <= 0 ||
                  this.showHiddenFields){
                  this.selectedRelaventProfileIdList.push('All');
                }
                this.checkedProfiles = profileList;
                this.relevantProfilesList = profileList;
                // this.relevantProfilesList.push({"metadata_profile_id":"All","name":"All"});
              }
              this.updateFieldsView();
            },
            refreshStartData(keyName){
              if(keyName == "user_groups" && Object.keys(this.getStartUpDataFromInCache()).includes("user_groups")){
                this.startupUserGroupList = this.getStartUpDataFromInCache()["user_groups"];
              }else if(keyName == "custom_metadatas" && Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
                this.customMetadataList = this.getStartUpDataFromInCache()["custom_metadatas"];
              }else if(keyName == "metadata_profiles" && Object.keys(this.getStartUpDataFromInCache()).includes("metadata_profiles")){
                let enableProfiles = true;
                if('screen_profile_required' in this.getStartUpDataFromInCache() &&
                  !this.getStartUpDataFromInCache()["screen_profile_required"]){
                  enableProfiles = false;
                }
                if(enableProfiles){
                  this.metadataProfileList = this.getStartUpDataFromInCache()["metadata_profiles"];
                }
              }else if(keyName == "screens" && Object.keys(this.getStartUpDataFromInCache()).includes("screens")){
                let screenExists = false;
                let screens = this.getStartUpDataFromInCache()["screens"];
                console.log("dddddddddddddddddd",screens,this.screenType)
                if(screens.length > 0){
                  let screensList = [];
                  screensList = screens.filter((a)=>a.name == this.screenType)
                  console.log("screensListscreensList",screensList,this.screenType)
                  if(screensList.length > 0){
                    screenExists = true;
                    let screenDetails = screensList[0];
                    this.uploadScreenInfo = JSON.parse(JSON.stringify(screenDetails));
                    this.tagMetadataScreenId = screenDetails._id;
                    let displayAlwaysList = screenDetails.display_always_field_id_list;
                    if(typeof displayAlwaysList != "undefined" && displayAlwaysList.length > 0){
                    if(this.enableOnlyFields == true){
                      this.displayAlwaysFieldsIdList = displayAlwaysList;
                      this.fetchedFieldIdList = this.displayAlwaysFieldsIdList;
                    }else{
                        Object.assign(this.displayAlwaysFieldsIdList, displayAlwaysList);
                        Object.assign(this.fetchedFieldIdList, this.displayAlwaysFieldsIdList);
                    }
                    }
                  }
                }
                if(!screenExists){
                  for(let eachDict of this.customMetadataList){
                    this.uploadScreenInfo.field_id_list.push(eachDict._id);
                  }
                }
              }
            },
          handleNotifications(notification){
          notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
          if(notification.message){
              let entry_info = notification.message
              if(notification.message_type == NotifierConstants.screenModifiedNotification){
                if(this.tagMetadataScreenId == entry_info.screen_id){
                  setTimeout(()=>{
                    this.refreshStartData("screens");
                    this.refreshStartData("user_groups");
                    if(this.enableOnlyFields != true){
                      this.fetchAndLoadRelaventMetadataProfiles(this.assetCustomMetadata);
                    }
                  },100);
                }
               }else if([NotifierConstants.fieldCreatedNotification].includes(notification.message_type)){
                          setTimeout(()=>{
                            this.refreshStartData("custom_metadatas");
                            if(this.enableOnlyFields != true){
                              this.fetchAndLoadRelaventMetadataProfiles(this.assetCustomMetadata);
                            }
                          }, 100);
              }else if([NotifierConstants.fieldModifiedNotification,
                        NotifierConstants.fieldRemovedNotification].includes(notification.message_type)){
                          setTimeout(()=>{
                            this.refreshStartData("custom_metadatas");
                            if(this.enableOnlyFields != true){
                              this.fetchAndLoadRelaventMetadataProfiles(this.assetCustomMetadata);
                            }
                          }, 100);
              }else if([NotifierConstants.screenProfileCreatedNotification,
                        NotifierConstants.screenProfileModifiedNotification,
                        NotifierConstants.screenProfileRemovedNotification].includes(notification.message_type)){
                        setTimeout(()=>{
                          this.refreshStartData("screens");
                          this.refreshStartData("metadata_profiles");
                          if(this.enableOnlyFields != true){
                              this.fetchAndLoadRelaventMetadataProfiles(this.assetCustomMetadata);
                            }
                        },100)
              }else if([NotifierConstants.userGroupCreatedNotification,
                        NotifierConstants.userGroupModifiedNotification,
                        NotifierConstants.userGroupRemovedNotification].includes(notification.message_type)){
                        setTimeout(()=>{
                          this.refreshStartData("user_groups");
                          if(this.enableOnlyFields != true){
                              this.fetchAndLoadRelaventMetadataProfiles(this.assetCustomMetadata);
                            }
                        },100)
              }else if(NotifierConstants.userRemovedNotification == notification.message_type){
                setTimeout(() =>{
                  if(this.enableOnlyFields != true){
                              this.fetchAndLoadRelaventMetadataProfiles(this.assetCustomMetadata);
                            }
                },100);
              }else if(NotifierConstants.catalogModifiedNotification == notification.message_type){
                  if(this.selectedCatParentIdList.includes(notification.message._id)){
                    this.$toast.info("Selected catalog is updated by another user");
                    let catIndex = this.selectedCatParentIdPathList.findIndex(op=>op._id == notification.message._id)
                    this.selectedCatParentIdPathList[catIndex] = notification.message;
                  }
              }else if(NotifierConstants.catalogRemovedCreatedNotification == notification.message_type){
                    if(this.selectedCatParentIdList.includes(notification.message._id)){
                      this.$toast.info("Selected catalog is deleted by another user");
                      if(Utils.getCookieValue("context") == "catalogs-display"){
                        this.getCategoryRoutefromId(this.getSelectedCategoryInCategoryBrowse,false);
                      }else if(this.defaultCategory != undefined){
                        this.getCategoryRoutefromId(this.defaultCategory,true);
                      }else{
                        let payload = {};
                        payload.params = {catalog_id:JSON.stringify(Constants.rootCategory)}
                        this.getAllAssetsFromServer(payload).then((data)=>{
                          this.getCategoryRoutefromId(data["assets"][0],false)
                        });
                      }
                    }
              }
          }
        },
        setAssetInfo(info){
          this.assetDetailsFromParent = {}
          Object.assign(this.assetDetailsFromParent,info);
          if(Object.keys(this.assetDetailsFromParent).includes("custom_metadata")){
            this.assetCustomMetadata = [],
            Object.assign(this.assetCustomMetadata, this.assetDetailsFromParent.custom_metadata);
          }else{
            this.assetDetailsFromParent = [];
          }
          if(Object.keys(this.assetDetailsFromParent).includes("catalog_path") || Object.keys(this.assetDetailsFromParent).includes("parent_path")){
              this.selectedCatParentIdList = [];
              this.selectedCatParentIdPathList = [];
              if (Object.keys(this.assetDetailsFromParent).includes("catalog_path")){
                if(this.assetDetailsFromParent.catalog_path.length > 0){
                  this.selectedCatParentIdPathList = this.assetDetailsFromParent.catalog_path;
                  this.selectedCatParentIdList = this.assetDetailsFromParent.catalog_id_path;
                  this.postcatalogKey = "catalog_id_path"
                }
              }else {
                if(this.assetDetailsFromParent.parent_path.length > 0){
                  this.selectedCatParentIdPathList = this.assetDetailsFromParent.parent_path;
                  this.selectedCatParentIdList = this.assetDetailsFromParent.parent_id_path;
                  this.postcatalogKey = "parent_id_path"
                }
              }
              if(this.selectedCatParentIdPathList.length > 0)this.selectedCatParentIdPathList = this.selectedCatParentIdPathList.filter(e => e._id != "0");
              if(this.selectedCatParentIdList.length > 0)this.selectedCatParentIdList = this.selectedCatParentIdList.filter(e => e != "catalog_id://0");
              if(this.selectedCatParentIdPathList.length > 0){
                this.route = this.selectedCatParentIdPathList[0]
              }
            this.fetchAndLoadRelaventMetadataProfiles(this.assetDetailsFromParent["custom_metadata"]);
          }
          this.mediaSlug = "";
          if(this.enableMediaSlug){
            this.mediaSlug = this.assetDetailsFromParent.slug_name;
          }
          this.description = "";
          if ("metadata" in this.assetDetailsFromParent){
            if(this.assetDetailsFromParent.metadata.description != null){
              this.description = this.assetDetailsFromParent.metadata.description
            }
          } 
          this.tagNamesList = [];
          if("tag_info" in this.assetDetailsFromParent){
            let tempList = [];
            tempList = Object.assign(tempList,this.assetDetailsFromParent.tag_info);
            for (let tag=0;tag<tempList.length;tag++){
              this.tagNamesList.push({"_id":tempList[tag].tag_id,"name":tempList[tag].name});
            }
          }
          this.isLoaded=true 
        },
        getWorkspaceCatalogInfo(routeUrl){
          let payload = {params:{assetId: routeUrl._id}}
                this.getAssetInfoFromServer(payload).then((data)=>{
                  this.getCategoryRoutefromId([data["asset"]],false);
                })
        },
    
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        ...mapActions("tags", ["getTagsOnAutocomplete"]),
        ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
        ...mapActions("assets", ["getAllAssetsFromServer", "getAutoCompletedAssetsFromServer","getAssetInfoFromServer"]),
        ...mapGetters("users",["getLoggedInUserPrivilege"]),
        ...mapMutations("startUpData",["updatestartupDatainfo"])
    },
    watch:{
        immediate:true,
        deep:true,
        parentData: function(newval){
            if(newval != undefined && Object.keys(newval).length){
                this.setAssetInfo(newval);
            }else{
                if(Utils.getCookieValue("context") == "catalogs-display"){
                    if(this.defaultCategory){
                        this.getCategoryRoutefromId(this.defaultCategory,true);
                    }else{
                        this.getWorkspaceCatalogInfo(this.getSelectedCategoryInCategoryBrowse);
                    }
                }else if(this.defaultCategory != undefined){
                    this.getCategoryRoutefromId(this.defaultCategory,true);
                }else{
                    this.getCategoryRoutefromId(this.getRootCategoryDetails,false)
                }
                this.description = "";
                this.tagNamesList = [];
                this.assetCustomMetadata = [];
            }
        },
        defaultCategory: function(newval){
            if(this.$route && this.$route.name && this.$route.name == 'upload'){
                this.getCategoryRoutefromId(newval,true);
            }
        },
        screenType:function(newVal){
            this.screenType = newVal;
            this.refreshStartData("user_groups");
            this.refreshStartData("metadata_profiles");
            this.refreshStartData('custom_metadatas');
            this.refreshStartData("screens");
        },

        onGoingChanges:function(newVal){
          console.log("onGoingChanges *************",newVal)
            if(this.onGoingChanges){
                this.assetCustomMetadata = this.onGoingChanges
            }
        }
    },
    created(){        
        if(this.assetsBrowseAccess && this.assetsBrowseAccess.length > 0){
            this.defaultAssetsBrowseAccess = this.assetsBrowseAccess
        }
        if(this.parentData && Object.keys(this.parentData).length ){
            Object.assign(this.parentAssetDetails,this.parentData);
        }

        this.refreshStartData("user_groups");
        this.refreshStartData("metadata_profiles");
        this.refreshStartData('custom_metadatas');
        this.refreshStartData("screens");
        if(this.screenType == "Upload"){
            this.enableCatalog = true;
            if(!Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege(), "tag-metadata")){
            this.enableFieldsWithMetadataPriv = false;
            }
        }
        if(this.parentAssetDetails != undefined && Object.keys(this.parentAssetDetails).length){
            this.setAssetInfo(this.parentAssetDetails);
        }else{
            console.log("this.parentRouteNamethis.parentRouteName",this.parentRouteName , this.parentRouteName == 'catalogs-display')
            if(['projects-display','catalogs-display'].includes(Utils.getCookieValue("context")) || (this.parentRouteName && this.parentRouteName == 'catalogs-display')){
              this.getWorkspaceCatalogInfo(this.getSelectedCategoryInCategoryBrowse);
            }else if(this.defaultCategory != undefined){
              this.getCategoryRoutefromId(this.defaultCategory,true);
            }else{
                let opt = this.getRootCategoryDetails
                let data1  = {};
                data1["_id"] = opt._id;
                data1["catalog_name"] = opt.catalog_name;
                data1["parent_id_path"] = [opt.parent_id_path[0]]
                data1["parent_path"] = [{"_id":opt.parent_id_path[0], "value":opt.parent_path[0].value}]
            this.getCategoryRoutefromId(data1,false)
            }
        }
        if(this.onGoingChanges){
            this.assetCustomMetadata = this.onGoingChanges
        }
        this.isLoaded=false;
        this.addWSEventListener({
            eventname:[NotifierConstants.screenModifiedNotification,
            NotifierConstants.userRemovedNotification,
            NotifierConstants.userGroupCreatedNotification,NotifierConstants.userGroupModifiedNotification,NotifierConstants.userGroupRemovedNotification,
            NotifierConstants.fieldCreatedNotification, NotifierConstants.fieldModifiedNotification, NotifierConstants.fieldRemovedNotification,
            NotifierConstants.screenProfileCreatedNotification,NotifierConstants.screenProfileModifiedNotification,NotifierConstants.screenProfileRemovedNotification,
            NotifierConstants.catalogModifiedNotification,NotifierConstants.catalogRemovedCreatedNotification,NotifierConstants.tagModifiedNotification,
            NotifierConstants.tagRemovedNotification],
            callback:this.handleNotifications,
            parent:"SequenceMetadata"})
    },
    beforeDestroy(){
        this.removeWSEventListener({
              eventname:[NotifierConstants.screenModifiedNotification,
              NotifierConstants.userRemovedNotification,
              NotifierConstants.userGroupCreatedNotification,NotifierConstants.userGroupModifiedNotification,NotifierConstants.userGroupRemovedNotification,
              NotifierConstants.fieldCreatedNotification, NotifierConstants.fieldModifiedNotification, NotifierConstants.fieldRemovedNotification,
              NotifierConstants.screenProfileCreatedNotification,NotifierConstants.screenProfileModifiedNotification,NotifierConstants.screenProfileRemovedNotification,
              NotifierConstants.catalogModifiedNotification,NotifierConstants.catalogRemovedCreatedNotification,NotifierConstants.tagModifiedNotification,
              NotifierConstants.tagRemovedNotification],
              callback:this.handleNotifications,
              parent:"SequenceMetadata"});
    },
}

export default highlightMixin;